
import Vue from "vue";
import router from "vue-router";
import { studyVideo } from '@/http/index'
import { Message } from 'element-ui'; // 使用 Element UI 的消息提示
import { userHospital } from '@/http/index'

Vue.use(router);

const constantRoutes = [
  {
    path: "/",
    redirect: "/syIndex"
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home"),
    children: [
      // {
      //   path: 'index',
      //   name: 'index',
      //   component: () => import("@/views/examIndex/index.vue")
      // },
      {
        path: 'examinationList',
        name: 'ExaminationList',
        component: () => import("@/views/examList/index.vue")
      },
      {
        path: 'examOutline',
        name: 'ExamOutline',
        component: () => import("@/views/examOutline/index.vue")
      },
      {
        path: 'examining',
        name: 'Examining',
        component: () => import("@/views/examining/index.vue")
      },
      {
        path: 'personal',
        name: 'Personal',
        component: () => import("@/views/personal/index.vue")
      },
      {
        path: 'videoList',
        name: 'videoList',
        component: () => import("@/views/videoList/index.vue")
      },
      {
        path: 'play',
        name: 'play',
        component: () => import("@/views/videoList/play.vue")
      },
      {
        path: 'message',
        name: 'message',
        component: () => import("@/views/message/index.vue")
      },
      {
        path: 'messageDetails',
        name: 'messageDetails',
        component: () => import("@/views/message/details.vue")
      },
      {
        path: 'review',
        name: 'review',
        component: () => import("@/views/examining/review.vue")
      }

    ]
  },
  {
    path: "/syIndex",
    name: "syIndex",
    component: () => import("@/views/syHome/index.vue")
  },
  {
    path: "/syIframe",
    name: "syIframe",
    component: () => import("@/views/syHome/iframe.vue")
  }
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("@/views/login/index.vue")
  // },
  // {
  //   path: "/forget",
  //   name: "forget",
  //   component: () => import("@/views/login/forget.vue")
  // }
];

// 防止连续点击多次路由报错
const routerPush = router.prototype.push;
router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

const Router = new router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});

function detectBlockedDevice() {
  const userAgent = navigator.userAgent || '';
  const lowerUserAgent = userAgent.toLowerCase();
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;
  const userAgentData = navigator.userAgentData || null;
  const screenWidth = window.screen.width || 0;
  const screenHeight = window.screen.height || 0;
  const shortestSide = Math.min(screenWidth, screenHeight);
  const longestSide = Math.max(screenWidth, screenHeight);
  const hasCoarsePointer = window.matchMedia ? window.matchMedia('(pointer: coarse)').matches : false;
  const mobileByUAData = !!(userAgentData && userAgentData.mobile);
  const mobileByUA = /iphone|ipod|android.+mobile|windows phone|blackberry|opera mini|opera mobi|mobile/i.test(lowerUserAgent);
  const tabletByUA = /ipad|tablet|playbook|kindle|silk/i.test(lowerUserAgent);
  const androidTabletByUA = /android/i.test(lowerUserAgent) && !/mobile/i.test(lowerUserAgent);
  const ipadDesktopMode = platform === 'MacIntel' && maxTouchPoints > 1;
  const vendorSpoofedTablet = /miuibrowser|xiaomi|huawei|honor|vivo|oppo|sm-t|lenovo tab|redmi pad/i.test(lowerUserAgent);
  const desktopByUA = /(windows nt|macintosh|cros|x11; linux x86_64|x11; ubuntu|x11; linux amd64)/i.test(lowerUserAgent);
  const strongDesktop = (platform.startsWith('Win') || platform === 'MacIntel' || /linux/i.test(platform)) && !hasCoarsePointer;

  if (mobileByUAData || mobileByUA) {
    return { blocked: true, reason: 'mobile' };
  }

  if (tabletByUA || androidTabletByUA || ipadDesktopMode) {
    return { blocked: true, reason: 'tablet' };
  }

  if (strongDesktop) {
    return { blocked: false, reason: 'desktop' };
  }

  let tabletScore = 0;
  if (maxTouchPoints >= 2) tabletScore += 2;
  if (hasCoarsePointer) tabletScore += 2;
  if (shortestSide >= 600 && shortestSide <= 1600) tabletScore += 2;
  if (longestSide >= 900) tabletScore += 1;
  if (vendorSpoofedTablet) tabletScore += 2;
  if (desktopByUA) tabletScore += 1;

  if (tabletScore >= 6) {
    return { blocked: true, reason: 'tablet-spoofed-desktop' };
  }

  return { blocked: false, reason: 'desktop' };
}

// 守卫
Router.beforeEach((to, form, next) => {
  const device = detectBlockedDevice();
  if (device.blocked) {
    Message({
        message: '访问失败，请到电脑端打开该链接',
        type: 'warning',
        duration: 2000 // 显示 2 秒
    });
    return;
  } else {
    // 检查路由是否存在
    if (!to.matched.length) {
      next({ name: 'syIndex' });
      return;
    }
    if (!localStorage.getItem("token")) {
      if (to.name === 'syIndex') {
        next()
      } else {
        next({ name: "syIndex" });
      }
    } else {
      const lookVideoInfo = JSON.parse(localStorage.getItem('lookVideoInfo'))
      if (lookVideoInfo) {
        lookVideoInfo.last_viewing_at = localStorage.getItem('lookVideoTime')
        studyVideo(lookVideoInfo).then(res => {
          if (res.code == 200) {
            localStorage.removeItem('lookVideoInfo')
            localStorage.removeItem('lookVideoTime')
          }
        })
      }
      if (to.name === 'syIndex') {
        next()
      } else {
        if(!localStorage.getItem('hospital_id')){
          next()
          return
        }
        userHospital({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id')
        }).then(res => {
          const testRole = res.data.find(item => item.id == localStorage.getItem('hospital_id')).system_role;
          const showPage = to.name != 'syIframe' ? 'ksxt' : to.query.path.search('training') != -1 ? "thinking_training_system" : to.query.path.search('skill') != -1 ? "skill_practice_system" : "shengyun_exam_system"
          // console.log(showPage, 'showPage')
          if (testRole.find(item => item.system === showPage).status == 1) {
            next()
          } else {
            next({ name: "syIndex" });
          }
        })
      }
    }
  }
});

export default Router;
